import { render, staticRenderFns } from "./TermsPending.vue?vue&type=template&id=22adbe42"
import script from "./TermsPending.vue?vue&type=script&lang=js"
export * from "./TermsPending.vue?vue&type=script&lang=js"
import style0 from "./TermsPending.vue?vue&type=style&index=0&id=22adbe42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports